/**
 * Narrow a possibly-loose SDK field into the canonical
 * `{ rasterise: boolean } | null` shape used by `<UserAvatar rasterise>`
 * via `<UserIdentity user.avatarPreferences>`. The SDK ships this as a
 * jsonb column, so it always returns as a structurally-typed object —
 * but every social-tab mapper builds a fresh literal from `Record<string,
 * <T>` rows so we narrow defensively here in one place. The generic
 * `<T>` argument keeps the function specific-typed (not `unknown`) at
 * the boundary; callers pass the indexed value directly.
 */
export function parseAvatarPreferences<T>(raw: T): { rasterise: boolean } | null {
  if (raw === null || raw === undefined) return null;
  if (typeof raw !== 'object') return null;
  const obj = raw as { rasterise?: boolean | null };
  return typeof obj.rasterise === 'boolean' ? { rasterise: obj.rasterise } : null;
}
